import React from "react";
import { ClearButton, SubscriptionButton } from "./WebSocketTestPageButtons";
import { MessagesList, Message } from "./MessagesList";

interface ChannelSectionProps {
  title: string;
  isPrivate?: boolean;
  messages: Message[];
  onClearMessages: () => void;
  children: React.ReactNode; // Subscription buttons
  emptyMessage?: string;
}

export const ChannelSection: React.FC<ChannelSectionProps> = ({
  title,
  isPrivate = false,
  messages,
  onClearMessages,
  children,
  emptyMessage,
}) => {
  return (
    <div className="channel-section">
      <div className="channel-header">
        <h2 className="channel-title">{title}</h2>
        <ClearButton onClick={onClearMessages} />
      </div>
      <div className="channel-content">
        <div className="channel-buttons-container">{children}</div>
        <MessagesList
          messages={messages}
          isPrivate={isPrivate}
          emptyMessage={emptyMessage}
        />
        {isPrivate && (
          <div className="private-note">
            <strong>Note:</strong> Private channels require authentication.
            Enter your auth token in the configuration above.
          </div>
        )}
      </div>
    </div>
  );
};
